<template>
  <nav class="main-menu">
    <transition-group
      tag="ul"
      :css="false"
      @beforeEnter="handleFadeInInit"
      @enter="handleFadeInEnter"
      @leave="handleFadeInLeave"
    >
      <li
        v-for="(item, index) in animatedMenuItems"
        :key="item.name"
        :data-order="index"
        :data-delay-interval="50"
        :data-delay-base="200"
      >
        <span class="header" @click="moveTo(item.name)">
          {{ item.label }}
        </span>
      </li>
    </transition-group>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import toPath from '@/mixins/toPath';
import animations from '@/mixins/animations';

export default {
  mixins: [toPath, animations],
  data() {
    return {
      menuItems: [
        { label: 'Home', name: 'home' },
        { label: 'Vision', name: 'vision' },
        { label: 'Products', name: 'products' },
        { label: 'Team', name: 'team' },
        { label: 'Values', name: 'values' },
        { label: 'Careers', name: 'careers' },
      ],
    };
  },
  computed: {
    ...mapGetters(['menuOpened']),
    animatedMenuItems() {
      return this.menuOpened ? this.menuItems : [];
    },
  },
  methods: {
    ...mapMutations(['triggerClickedFromMenu', 'resetClickedFromMenu']),
    moveTo(name) {
      if (this.$route.name !== 'index') {
        this.$router.push({ name: 'index', params: { silentTo: name } });
      } else {
        console.log('moved!');
        this.$root.$emit('menu-click', name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu {
  flex: 1;
}

ul {
  margin: 0;
  padding-left: 4rem;
  @media (min-width: $sm) {
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    padding-left: 10rem;
    padding-right: 3.5rem;
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }
  @media (min-width: $xl) {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  li {
    min-width: 18rem;
    @media (min-width: $xl) {
      min-width: 24rem;
    }
    position: relative;
    overflow: hidden;
    margin-bottom: 0.6rem;
    @media (min-width: $xl) {
      margin-bottom: 0.3rem;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #493dad;
      transform: translate(-103%, 0%) matrix(1, 0, 0, 1, 0, 0);
      transition: transform 0.3s cubic-bezier(0.7, 0, 0.3, 1);
      z-index: -1;
    }
    &:hover {
      &:after {
        transform: translate(-73%, 0%) matrix(1, 0, 0, 1, 0, 0);
      }
      span {
        color: #fff;
        transform: matrix(1, 0, 0, 1, 40, 0);
      }
    }
    span {
      cursor: pointer;
      padding-top: 2%;
      @media (min-width: $sm) {
        padding-top: 2.5%;
      }
      @media (min-width: $xl) {
        padding-top: 3%;
      }
      text-decoration: none;
      letter-spacing: -1.5px;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.3);
      display: inline-block;
      transition: all 0.3s cubic-bezier(0.7, 0, 0.3, 1);
      vertical-align: text-top;
    }
  }
}
</style>
